import React from 'react';
import ConfigureLayout from '../../components/configure/ConfigureLayout';
import DisplaysContainer from '../../components/configure/displays/Displays';
const Displays = () => {
  return (
    <ConfigureLayout>
      <DisplaysContainer />
    </ConfigureLayout>
  );
};

export default Displays;
